/*
<summary>
   This file is used to provide initial values or state to the Process Module Observables.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { ITrayListVM } from '../../models/response/ITrayResponse';
const initialTrayState: ITrayListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Trays: [],
  SavedColumn: '',
};

export default initialTrayState;
